// Configuración de TiendaNube
export const TIENDANUBE_CONFIG = {
    // ID de la tienda Orsai en TiendaNube
    STORE_ID: '6571444',

    // URL base de la API de TiendaNube
    // En desarrollo usa el proxy, en producción usa la URL directa
    // Versión de API: 2025-03 (según documentación oficial)
    API_VERSION: '2025-03',
    API_BASE_URL: import.meta.env.DEV ? '/api/tiendanube' : 'https://api.tiendanube.com',

    // Para desarrollo, puedes usar un token temporal
    ACCESS_TOKEN: import.meta.env.VITE_TIENDANUBE_ACCESS_TOKEN || 'ab3dfbd6ddfdc3762a250d8f17f80dbb0a9a2c09',

    // Configuración de paginación
    PRODUCTS_PER_PAGE: 50,

    // URL de la tienda pública
    STORE_URL: 'https://talleres.orsai.org',

    // Endpoint para obtener talleres en producción (Netlify Function u otro backend).
    // Evita CORS y no expone el token. Si no se usa Netlify, configurar otra URL con VITE_TIENDANUBE_TALLERES_API.
    TALLERES_API_URL: import.meta.env.VITE_TIENDANUBE_TALLERES_API || '/.netlify/functions/tiendanube-talleres',

    // Headers por defecto
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
        'User-Agent': 'Orsai Tech (walter@orsai.org)'
    },

    // Configuración de cache
    CACHE: {
        // Habilitar cache en memoria (true = usa cache, false = consulta siempre API)
        ENABLED: import.meta.env.VITE_TIENDANUBE_CACHE_ENABLED !== 'false', // Por defecto habilitado
        
        // Tiempo de vida del cache en milisegundos (5 minutos por defecto)
        TTL: parseInt(import.meta.env.VITE_TIENDANUBE_CACHE_TTL) || 5 * 60 * 1000, // 5 minutos
        
        // Usar cache incluso en producción
        USE_IN_PRODUCTION: import.meta.env.VITE_TIENDANUBE_CACHE_IN_PROD !== 'false' // Por defecto habilitado
    }
};

// Función para obtener headers completos con autenticación
export function getTiendaNubeHeaders() {
    // En desarrollo, el proxy maneja la autenticación
    if (import.meta.env.DEV) {
        return TIENDANUBE_CONFIG.DEFAULT_HEADERS;
    }

    // En producción, agregar autenticación
    return {
        ...TIENDANUBE_CONFIG.DEFAULT_HEADERS,
        'Authentication': `bearer ${TIENDANUBE_CONFIG.ACCESS_TOKEN}`
    };
}

// Función para construir la URL completa de la API
export function getTiendaNubeApiUrl(endpoint = '') {
    // Formato: https://api.tiendanube.com/2025-03/{store_id}/{endpoint}
    if (import.meta.env.DEV) {
        // En desarrollo, el proxy ya maneja la versión
        return `${TIENDANUBE_CONFIG.API_BASE_URL}/${TIENDANUBE_CONFIG.STORE_ID}${endpoint ? `/${endpoint}` : ''}`;
    }
    // En producción, incluir la versión de la API
    return `${TIENDANUBE_CONFIG.API_BASE_URL}/${TIENDANUBE_CONFIG.API_VERSION}/${TIENDANUBE_CONFIG.STORE_ID}${endpoint ? `/${endpoint}` : ''}`;
}

// Función para construir la URL pública de un producto
export function getProductPublicUrl(handle) {
    return `${TIENDANUBE_CONFIG.STORE_URL}/products/${handle}`;
}
